const WORDS_PER_SECOND = 0.000002
const ONE_SECOND = 1000

function css(elem, rules = {}) {
	Object.keys(rules).forEach((key) => {
		elem.style[key] = rules[key]
	})
}

// https://stackoverflow.com/a/17980070/7027045
function stripHTML(html = '') {
	const tmp = document.implementation.createHTMLDocument('New').body
	tmp.innerHTML = html
	return tmp.textContent || tmp.innerText || ''
}

function getDurationBasedOnWords(content) {
	const words = stripHTML(content).split(' ')
	return (words.length * ONE_SECOND) / WORDS_PER_SECOND
}

function getThemeHexCode(theme) {
	switch (theme) {
		case 'success':
			return '#47DB8B'
		case 'error':
			return '#FF5A5A'
		default:
			return '#359EEB'
	}
}

/**
 *
 * @param {string} title
 * @param {string} description
 * @param {"success" | "error" | "info"} type
 * @param {{}} opts
 */
function notification(
	title = '',
	description = '',
	theme = 'success',
	opts = {}
) {
	const {
		className = '',
		duration = getDurationBasedOnWords(description),
		target = 'body',
		offset = 15,
		styles = {},
		selector = 'just-toasty',
		role = 'alert',
		type = 'polite',
		cb = () => {}
	} =
		typeof opts === 'number'
			? { duration: opts }
			: typeof opts === 'function'
			? { cb: opts }
			: opts

	const [vert, hor] = ['top', 'right']
	const targetElem = document.querySelector(target)
	const elem = document.createElement('div')

	elem.setAttribute('role', role)
	elem.setAttribute('aria-live', type)
	elem.setAttribute('aria-atomic', 'true')

	elem.classList.add(selector)
	className && elem.classList.add(className)

	const heading = document.createElement('h6')
	css(heading, {
		fontSize: '16px',
		color: '#44344F',
		margin: '0',
		paddingBottom: '7px'
	})
	heading.innerHTML = title

	const body = document.createElement('p')
	body.innerHTML = description
	css(body, {
		fontSize: '14px',
		fontWeight: 'normal',
		color: '#A8A4B1',
		margin: 0
	})

	elem.appendChild(heading)
	elem.appendChild(body)

	css(elem, {
		borderLeft: `6px solid ${getThemeHexCode(theme)}`,
		[hor]: '15px',
		opacity: 1,
		padding: '1em 1.5em',
		zIndex: 9999,
		background: '#ffffff',
		display: 'inline-block',
		position: 'fixed',
		borderRadius: '6px',
		top: '-100px',
		fontFamily: 'inherit',
		fontSize: '16px',
		fontWeight: 'bold',
		transition: 'all 0.4s ease-out',
		height: '97px',
		width: '350px',
		boxShadow: '1px 17px 30px rgba(194, 195, 199, 0.35)',
		...styles
	})

	targetElem.insertBefore(elem, targetElem.firstChild)

	let topOffset = offset

	document.querySelectorAll(`.${selector}`).forEach((elem) => {
		const height = elem.clientHeight
		css(elem, {
			[vert]: `${topOffset}px`
		})
		topOffset += height + offset
	})

	setTimeout(function () {
		const width = elem.offsetWidth
		css(elem, {
			[hor]: `-${width}px`,
			opacity: 0
		})
		setTimeout(() => {
			elem.remove()
			cb()
		}, 1000)
	}, duration)

	return elem
}

const SUCCESS_TITLE = 'Success'
const ERROR_TITLE = 'Error'
const INFO_TITLE = 'Information'
const NOTIFY_PERIOD = 1500

export function errorNotification(message) {
	notification(ERROR_TITLE, message, 'error', 5000)
}
export function successNotification(message) {
	notification(SUCCESS_TITLE, message, 'success', NOTIFY_PERIOD)
}
export function infoNotification(message, period = NOTIFY_PERIOD) {
	notification(INFO_TITLE, message, 'info', period)
}

/**
 * Pops success notification that reads "Save successful"
 */
export function successfulSaveNotification() {
	notification(SUCCESS_TITLE, 'Save successful', 'success', NOTIFY_PERIOD)
}
